<mat-menu xPosition="before" class="w-44 no-menu-padding mt-2">
  <ng-container *transloco="let t">
    <ul>
      @for (menuAction of menuActions(); track menuAction.action) {
      <li>
        <button
          mat-menu-item
          class="menu-item"
          [class.menu-item--danger]="menuAction.danger"
          [disabled]="menuAction.disabled"
          (click)="actionOutput.emit(menuAction.action)"
        >
          <span class="menu-item__content" [style.gap]="menuAction.styleConfig?.gap">
            @if (menuAction.svgIcon) {
            <mat-icon
              [svgIcon]="menuAction.svgIcon"
              [class]="menuAction.styleConfig?.iconClass ?? 'size-4! text-primary!'"
            ></mat-icon>
            }
            <span [class]="menuAction.styleConfig?.labelClass">{{ t(menuAction.label) }}</span>
          </span>
        </button>
      </li>
      }
    </ul>
  </ng-container>
</mat-menu>
